import { markRaw } from 'vue';

import LeadgenFormLeadModalContent from '@/ui/components/LeadgenFormLeadModalContent.vue';

/**
 * Opens the lead modal over the lead list while the route holds a `leadId`, and goes back to the
 * list (with its filters) when the modal is closed. The host provides `leadListPath` (computed) and
 * a `list` ref to the LeadgenFormLeadsList, which gets the changes made in the modal.
 */
export default {
  data: () => ({
    leadModal: null,
  }),
  watch: {
    '$route.params.leadId': {
      immediate: true,
      handler(leadId) {
        this.closeLeadModal();

        if (leadId) {
          this.openLeadModal(leadId);
        }
      },
    },
  },
  beforeUnmount() {
    this.closeLeadModal();
  },
  methods: {
    openLeadModal(leadId) {
      const modal = this.$fullscreenModal.open(
        this,
        LeadgenFormLeadModalContent,
        { leadId },
        {
          closeWithOutclick: true,
          componentListeners: {
            updated: lead => this.$refs.list?.updateLead(lead),
          },
        },
      );

      // Raw, so it compares equal to the handle the events come from.
      this.leadModal = markRaw(modal);

      modal.$on('closed', () => {
        if (this.leadModal !== modal) {
          return;
        }

        this.leadModal = null;
        if (this.$route.params.leadId !== leadId) {
          return;
        }

        // Opened from the list: step back, as the browser's back button would, so the lead
        // is not left in the history in front of the list.
        const previousPath = window.history.state?.back?.split('?')[0];
        if (previousPath === this.leadListPath) {
          this.$router.back();
        }
        else {
          this.$router.push({ path: this.leadListPath, query: this.$route.query });
        }
      });
    },
    closeLeadModal() {
      const modal = this.leadModal;
      this.leadModal = null;
      modal?.close();
    },
  },
};
